import React from 'react';

import './Footer.css';

const Footer = () => {
  const footer_text = "Mitsubishi UFJ Financial Group, Inc. All rights reserved. The MUFG logo and name is a service mark of Mitsubishi UFJ Financial Group, Inc. and is used by MUFG Bank, Ltd., with permission.";
  const currentYear = new Date().getFullYear();


  return (
    <footer>
      <span className="footer__copyright">
        © {currentYear} {footer_text}
      </span>
    </footer>
  );
};

export default Footer;
